import { ColumnProps } from 'antd/lib/table';
import { renderMoodIndicatorColumn } from 'Pages/Dashboard/tabs/columns.helpers';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';

export function getGroupSummaryColumns(): ColumnProps<OverviewGroupSummary>[] {
	return [
		{
			title: 'Group Name',
			key: 'groupName',
			dataIndex: 'groupName',
			sorter: true
		},
		{
			title: 'SAQ Compliance',
			key: 'indexComposite',
			dataIndex: 'indexComposite',
			render: renderMoodIndicatorColumn,
			sorter: true
		},
		{
			title: 'Phishing',
			key: 'phishingScore',
			dataIndex: 'phishingScore',
			render: renderMoodIndicatorColumn,
			sorter: true
		},
		{
			title: 'Training',
			key: 'elearningScore',
			dataIndex: 'elearningScore',
			render: renderMoodIndicatorColumn,
			sorter: true
		},
		{
			title: 'Scanning',
			key: 'spotCheckScore',
			dataIndex: 'spotCheckScore',
			render: renderMoodIndicatorColumn,
			sorter: true
		}
	];
}
